import ControllerBase from '../../../../global/js/ControllerBase';

export default class FooterController extends ControllerBase {

	private lastHero;
	private bgColor;

	constructor(element: HTMLElement) {
		super(element);
		this.disruptorFinder();
	}

	private disruptorFinder() {
		this.bgColor = this.$element?.querySelector('.m-ahu-footer__outer-wrap')?.getAttribute('data-bg-color') || '';
		this.lastHero = document.querySelector('.m-ahu-hero.main-last-item') as HTMLElement;
		if (this.lastHero && !this.lastHero.classList.contains('m-ahu-background-image')) this.lastHero.classList.add(this.bgColor);
	}

}
